module.exports = __webpack_public_path__ + "static/media/reviewquestions.54d76b1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reviewquestions.png
// module id = 890
// module chunks = 0